import React, { useContext } from "react";
import { GlobalContext } from "../../../../app/providers/GlobalState";

import { useFiltros } from "../FiltrosContext";

import BotaoAdicionar from "./BotaoAdicionar";
import CaixaPesquisa from "./CaixaPesquisa";
import FiltroSelect from "./FiltroSelect";
import SwitchAtivo from "./SwitchAtivo";
import BotaoVoltar from "./BotaoVoltar";

const FiltrosMobile = ({ edicoes, categorias }) => {
    const globalContext = useContext(GlobalContext);
    const acesso = globalContext.acessos?.find(x => x.func === 1);

    const { pesquisa, setPesquisa, edicao, setEdicao, categoria, setCategoria, ativo, setAtivo, setDrawerVisivel, setTurmaId } =
        useFiltros();

    return (
        <div className="filtros filtros-mobile">
            <div className="bloco-esquerda bloco-esquerda-cursos">
                <div className="controlos" style={{ display: "flex", justifyContent: "space-between", marginBottom: 0 }}>
                    {acesso?.create && (
                        <BotaoAdicionar
                            ativo={ativo}
                            onClick={() => {
                                setDrawerVisivel(true);
                                setTurmaId(null);
                            }}
                        />
                    )}
                    <div className="filtros" style={{ paddingTop: 8 }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <SwitchAtivo checked={ativo} onChange={setAtivo} />
                            <BotaoVoltar to="/utilizador" />
                        </div>
                    </div>
                </div>
                <div className="bloco-filtros">
                    <CaixaPesquisa pesquisa={pesquisa} placeholder="Procura" tem_placeholder onChange={setPesquisa} />
                    <FiltroSelect value={edicao} options={edicoes} onChange={setEdicao} placeholder="Edição" />
                    <FiltroSelect value={categoria} options={categorias} onChange={setCategoria} placeholder="Nível" />
                </div>
            </div>
        </div>
    );
};

export default FiltrosMobile;
